import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as state from '../../../../../state'
import * as value from '../value'

/** TODO:  */
@ngCore.Component({
  imports: [value.Component],
  selector: 'atn-display-field',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.dms.schema.Feature} */
  private readonly _schemaFeature = ngCore.inject(state.dms.schema.Feature)

  /** @see {@link ents.core.display.Field} */
  public readonly fieldSg = ngCore.input.required<ents.core.display.Field>({
    alias: 'field',
  })

  /** @see {@link ents.core.display.Field.Metadata } */
  private readonly _metadataSg = ngCore.computed(
    (
      field = this.fieldSg(),
      schema = this._schemaFeature.selectors.schema.asSignal(),
    ) =>
      field.meta
        ? ents.core.display.Field.Metadata.Source.getMetadata(
            field.meta,
            schema,
          )
        : undefined,
  )

  /** @see {@link ents.core.display.Field.Metadata.type } */
  public readonly typeSg = ngCore.computed(
    (metadata = this._metadataSg()) => metadata?.type,
  )

  /** @see {@link ents.core.display.Field.Metadata.name } */
  public readonly labelSg = ngCore.computed(
    (metadata = this._metadataSg()) => metadata?.name,
  )

  /** @see {@link ents.core.display.Field.value } */
  public readonly valueSg = ngCore.computed(
    (field = this.fieldSg()) => field.value,
  )

  /** @see {@link ents.core.display.Field.readonly } */
  public readonly readonlySg = ngCore.computed(
    (field = this.fieldSg()) => field.readonly,
  )

  /**
   * __NOTE:__ Only applicable when {@link readonlySg} is not `true`.
   */
  public readonly valueChange =
    ngCore.output<ents.core.display.Field['value']>()
}
